export type TutorBookingDetailsAudience = 'user' | 'host' | 'tutor';

export function tutorBookingDetailsPath(
  audience: TutorBookingDetailsAudience,
  bookingId: string,
): string {
  switch (audience) {
    case 'host':
      return `/host/tutor-requests/${bookingId}`;
    case 'tutor':
      return `/tutor/requests/${bookingId}`;
    default:
      return `/user/tutor-bookings/${bookingId}`;
  }
}

export function resolveTutorBookingDetailsAudience(pathname: string): TutorBookingDetailsAudience {
  if (pathname.startsWith('/host/tutor-requests/') && pathname !== '/host/tutor-requests') {
    return 'host';
  }
  if (pathname.startsWith('/tutor/requests/') && pathname !== '/tutor/requests') {
    return 'tutor';
  }
  return 'user';
}

export function tutorBookingDetailsListPath(audience: TutorBookingDetailsAudience): string {
  switch (audience) {
    case 'host':
      return '/host/tutor-requests';
    case 'tutor':
      return '/tutor/requests';
    default:
      return '/user/tutor-bookings';
  }
}
